/* eslint-disable no-console */
<template>
  <div>
    <div class="header_unit header_bg_white">
      <div class="header_box">
        <div class="menu_left">
          <router-link class="icn_back_black" :to="{ name: 'dashboard' } ">
            <p class="top_tit">＜戻る</p></router-link>
        </div>
        <div class="menu_center">
          <p v-if="alertId == 0" class="menu_center_tex_l top_tit">異常未対応店舗（温湿度異常）</p>
          <p v-else-if="alertId == 1" class="menu_center_tex_l top_tit">異常未対応店舗（通信異常）</p>
          <p v-else-if="alertId == 2" class="menu_center_tex_l top_tit">デイリーチェック未対応店舗</p>
          <p v-else class="menu_center_tex_l top_tit">不定期帳票未対応店舗</p>
        </div>
      </div>
    </div>
    <div class="main_unit" style="display: flex;justify-content: center;" v-if="!isInitLoading">
      <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
      <div class="dashboard_List_tbl_unit tbl_bg_blue" >

        <div v-if="validationMessage" class="mgt_20 mgb_20 mgl_20">
          <Message :validationMessage="validationMessage" />
        </div>
        <div v-if="apivalidationMessage" class="mgt_20 mgb_20 mgl_20">
          <Message :validationMessage="apivalidationMessage" />
        </div>

        <table>
          <tbody>
          <tr class="text-center">
            <th class="wd80 alertList_text_align border_bottom_none">リマインド<br>メール<br>送信店舗</th>
            <th class="wd50 alertList_text_align" rowspan="2">順位</th>
            <th class="wd200 alertList_text_align">店舗名</th>
            <th v-if="alertId == 0 || alertId == 1" class="alertList_text_align" style="min-width:110px" rowspan="2" @click="sortBy('allAlertCount')">
              異常発生総件数
              <img class="triangle" v-if="sortOrders['allAlertCount'] > 0" :src="triangleImage['allAlertCount']" width="15px" height="13px" alt="UnderTriangle">
              <img class="triangle" v-if="sortOrders['allAlertCount'] <= 0" :src="triangleImage['allAlertCount']" width="15px" height="13px" alt="UpTriangle">
            </th>
            <th v-if="alertId == 0 || alertId == 1" class="alertList_text_align" style="min-width:110px" rowspan="2" @click="sortBy('errorAlertCount')">
              未対応件数
              <img class="triangle" v-if="sortOrders['errorAlertCount'] > 0" :src="triangleImage['errorAlertCount']" width="15px" height="13px" alt="UnderTriangle">
              <img class="triangle" v-if="sortOrders['errorAlertCount'] <= 0" :src="triangleImage['errorAlertCount']" width="15px" height="13px" alt="UpTriangle">

            </th>
            <th v-if="alertId == 0" class="wd50 alertList_text_align" rowspan="2" >温湿度データ<br>一覧</th>
            <th v-if="alertId == 2 || alertId == 3" class="wd80 alertList_text_align" rowspan="2" @click="sortBy('implementationRate')">チェック<br>実施率
              <img class="triangle" v-if="sortOrders['implementationRate'] > 0" src="../assets/img/UpTriangleRed.png" width="15px" height="13px" alt="UnderTriangle">
              <img class="triangle" v-if="sortOrders['implementationRate'] <= 0" src="../assets/img/UnderTriangleRed.png" width="15px" height="13px" alt="UpTriangle">
            </th>
            <th v-if="(alertId == 2 || alertId == 3) && topButton['dailyCheck1']['displayFlg'] == 1" class="wd85 alertList_text_align" rowspan="2" >{{topButton['dailyCheck1']['name']}}</th>
            <th v-if="(alertId == 2 || alertId == 3) && topButton['dailyCheck2']['displayFlg'] == 1" class="wd85 alertList_text_align" rowspan="2" >{{topButton['dailyCheck2']['name']}}</th>
            <th class="wd50 alertList_text_align" rowspan="2">月間推移<br>グラフ</th>
          </tr>
          <tr>
            <th class="border_top_none alertList_text_align">一括
              <input type="checkbox" name="checkbox02" id="01-A" v-model="selectAll" @change="selectAllStore">
              <label for="01-A" class="checkbox02"></label>
            </th>
            <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
          </tr>

          <tr v-for="(alertList, index) in filteredDatas" :key="index">
            <td class="alertList_text_align text_white_space">
              <input type="checkbox" name="checkbox02" :id="alertList.id" v-model="selectedStoreIds" :value="alertList.id" @click="selectItemClick()">
              <label class="checkbox02" :for="alertList.id"></label>
            </td>
            <td class="alertList_text_align text_white_space">{{alertList.rank}}</td>
            <td class="tbl_tex_left_pd5 text_white_space">{{alertList.storeName}}</td>
            <td v-if="alertId == 0 || alertId == 1" class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputSensorAccident(alertList.id, 1)">{{alertList.allAlertCount}}件<br>CSV</a>
            </td>
            <td v-if="alertId == 0 || alertId == 1" class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputSensorAccident(alertList.id,0)">{{alertList.errorAlertCount}}件<br>CSV</a>
            </td>
            <td v-if="alertId == 0" class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputTemperatureHumidity(alertList.id)">温湿度一覧<br>CSV</a>
            </td>
            <td v-if="alertId == 2 || alertId == 3" class="alertList_text_align dashboard_staff_kanri_box">
              <a style="color:black">{{alertList.implementationRate}}%</a>
            </td>
            <td v-if="(alertId == 2 || alertId == 3) && topButton['dailyCheck1']['displayFlg'] == 1" class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputDailyReport(alertList.id,1)">{{topButton['dailyCheck1']['name']}}<br>CSV</a>
            </td>
            <td v-if="(alertId == 2 || alertId == 3) && topButton['dailyCheck2']['displayFlg'] == 1" class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="csvOutputDailyReport(alertList.id,4)">{{topButton['dailyCheck2']['name']}}<br>CSV</a>
            </td>
            <td class="alertList_text_align dashboard_staff_kanri_box">
              <a href="#" @click.prevent.stop="setStoreId(alertList.id)" class="icn_back_black">
                グラフ<br>表示</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="wd400 alert_request_box">
        <a href="#" @click.prevent.stop="sendRemindAlert" style="display:inline-flex;height:60px; width:100%;padding: 5px 0;margin: 10px 0px; color: black; justify-content: center; align-items: center; background-color: #4DA7D6;">メール一括送信</a>
        <textarea class="texbox_h475" placeholder="送信内容を記入してください。" v-model="body" maxlength="400"></textarea>
      </div>
    </div>
    <div class="overlay" v-show="showContentMail">
      <div>
        <div class="modal_box wd512">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit_s">温湿度異常対応</p>
              <p class="modal_header_tit">アラートリマインドメール</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p v-if="mailApiResult">リマインドメールの送信<br>が完了しました。</p>
            <p v-else>リマインドメールの送信<br>が失敗しました。</p>
            <div v-if="!mailApiResult">■未送信一覧<br>
              <ul>
                <li v-for="store in unSentStores" :key="store">{{store.storeName}}</li>
              </ul>
            </div>
          </div>
          <div class="btn_submit_box">
            <div class="btn_submit2">
              <a role="button" @click.prevent.stop="closeModalMail">閉じる</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showContentCsv">
      <div>
        <div class="modal_box wd512">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit">CSV出力</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p>CSV出力が完了しました。</p>
          </div>

          <div class="btn_submit">
            <a href="#" @click.prevent.stop="closeModelCsv">OK</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/app/components/Message.vue'
import PulseLoader from '@/app/components/PulseLoader.vue'

export default {
  name: 'dashboardAlertList',
  components: {
    Message,
    PulseLoader
  },
  props: {
    startDate: String,
    endDate: String,
  },
  computed:{
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
    filteredDatas:function(){
      var data = this.alertListData;

      var sortKey = this.sortKey;

      if(sortKey){
        var order = this.sortOrders[sortKey] || 1;
        data = data.slice().sort(function(a,b){
          a =  Number(a[sortKey]);
          b =  Number(b[sortKey]);
          return(a === b ? 0 : a > b? 1 : -1) * order;
        });
      }
      var filterWord = this.searchWord && this.searchWord.toLowerCase();
      if(filterWord){
        data = data.filter(function (row){
          return Object.keys(row).some(function (){
            return String(row["storeName"]).toLowerCase().includes(filterWord)
          })
        })
      }

      return data;

    },
    alertId: function () {
      return this.$store.getters['dashboard/selectedAlertId']
    },
    areaId: function () {
      return this.$store.getters['dashboard/selectedAreaId']
    },
  },
  data: function () {
    return {
      test:true,
      isInitLoading:false,
      validationMessage:"",
      apivalidationMessage:"",
      alertMessage:'入力エラーがあります。',
      alertListData:[],
      showContentMail:false,
      showContentCsv:false,
      isLoading:false,
      selectAll:false,
      searchWord:'',
      selectedStore:[],
      selectedStoreIds: [],
      mailApiResult:false,
      unSentStores:{},
      body:"",
      addFormFlg:false,
      csvResponseData: [],
      csvTempResponseData: [],
      csvHumidiResponseData: [],
      sortKey: 'allAlertCount',
      sortOrders:{
        'allAlertCount': -1,
        'errorAlertCount': 1,
        'implementationRate': 1
      },
      triangleImage: {
        'allAlertCount': require(`../assets/img/UpTriangleRed.png`),
        'errorAlertCount': require(`../assets/img/UnderTriangleWhite.png`)
      },
      topButton:{
        'dailyCheck1':{'displayFlg': false, 'name':''},
        'dailyCheck2':{'displayFlg': false, 'name':''},
      }
    }
  },
  created: function(){
    this.calc();
  },
  methods: {
    calc:async function() {

      this.isInitLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";

      // 企業ブランドIDの取得
      this.brandId = this.$store.getters['brand/id']
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        areaId: this.areaId,
        alertId: this.alertId,
      };

      // DBデータ取得
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/dashboard/alertList', {params})
          .then(response => {
            this.alertListData = response['data']['sensorAccidentList'];
            this.topButton = response['data']['topButton'];
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params: {brandPath: this.brandPath}}
              }
            }
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(() => this.isInitLoading = false);
    },
    sendRemindAlert: async function() {
      this.isLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";
      this.addFormFlg = true;
      this.selectedStore = [];
      this.unSentStores = {};

      this.brandId = this.$store.getters['brand/id']
      if(this.selectedStoreIds.length > 0) {
        //送信対象店舗idをリスト表示順で取得
        this.selectedStore = this.alertListData.filter(item => this.selectedStoreIds.includes(item.id)).map(item => item.id);
      }else {
        this.validationMessage = "店舗が選択されていません。"
        this.isLoading = false;
        this.addFormFlg = false;
      }
      if(this.body.length > 400){
        this.validationMessage="本文は400文字以下で入力してください。";
        this.isLoading = false;
        this.addFormFlg = false;
      } else if(this.body.length == 0){
        this.validationMessage="本文を入力してください。";
        this.isLoading = false;
        this.addFormFlg = false;
      }


        if(this.addFormFlg) {
          const params = {
            storeIds: this.selectedStore,
            body: this.body
          };
          await this.$axios
              .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/dashboard/alertList/sendRemainedAlertMail', {params})
              .then(response => {
                this.mailApiResult = response['data']['result'];
                if (this.mailApiResult) {
                  this.unSentStores = {};
                  this.selectedStoreIds = [];
                  this.selectAll = false;
                } else {
                  let unSentStoresResult = response['data']['unSentStore'];
                  this.selectedStoreIds = unSentStoresResult;
                  this.unSentStores = this.alertListData.filter(item => unSentStoresResult.includes(item.id));
                }
                this.showContentMail = true;
              })
              .catch((err) => {
                let error = {
                  button: {
                    path: {name: 'top', params: {brandPath: this.brandPath}}
                  }
                }
                if (err.customError) {
                  error = Object.assign(error, err.customError)
                }
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }).finally(() => this.isLoading = false);
        }
    },
    async csvOutputSensorAccident(id, isImplementation) {
      this.isLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";
      let brandId = this.$store.getters['brand/id'];
      let storeId = id;
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        alert_type:this.alertId,
        isImplementation:isImplementation,
      };
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/dashboard/alertList/' + storeId + '/sensor_accident/csv', {params})
          .then(response => (this.csvResponseData = response))
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              } else if (error.code == 401) {
                //店舗管理者のtokenエラーの場合
                this.$cookies.set('user-api-token', '', 0)
                this.$store.dispatch('store/doClear')
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isLoading = false);
      if(!this.commonDownloadCSV(this.csvResponseData)){
        this.apivalidationMessage =  "CSVの出力に失敗しました。";
      }
      else{
        this.showContentCsv = true;
      }
    },
    async csvOutputTemperatureHumidity(id){

      // CSV出力処理
      this.isLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";
      let brandId = this.$store.getters['brand/id'];
      let storeId = id;

      // リクエスト、URL成形
      var params = new Object();
      params = {
        start_date: this.startDate,end_date:this.endDate,type:1
      };
      // API呼び出し
      //温度センサーCSV
      await this.$axios
          .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/temperature_humidity/csv' ,{params})
          .then(response => {
            this.csvTempResponseData = response
            params = {
              start_date: this.startDate,end_date:this.endDate,type:2
            };
            //湿度センサーCSV
            return this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/temperature_humidity/csv' ,{params})
          })
          .then(response => {
            this.csvHumidiResponseData = response
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            this.addFormFlg = false;
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.apivalidationMessage =  error.message;
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isLoading = false);
      // CSV出力
      if(!this.commonDownloadCSV(this.csvTempResponseData) || !this.commonDownloadCSV(this.csvHumidiResponseData)){
        this.apivalidationMessage =  "CSVの出力に失敗しました。";
      }
      else{
          this.showContentCsv = true;
      }
    },
  async csvOutputDailyReport(id, topButtonNo) {
    this.isLoading = true;
    this.validationMessage = "";
    this.apivalidationMessage = "";
    let brandId = this.$store.getters['brand/id'];
    let storeId = id;
    var dailyCheckButtonFlg = 0;
    //不定期帳票
    if(this.alertId == 3) {
      dailyCheckButtonFlg = 1;
    }
    const params = {
      start_date: this.startDate,
      end_date: this.endDate,
      dailyCheckButtonFlg:dailyCheckButtonFlg,
      topButtonNo:topButtonNo,
    };

    await this.$axios
        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/daily/dashboard/csv', {params})
        .then(response => (this.csvResponseData = response))
        .catch((err) => {
          let error = {
            button: {
              path: {name: 'top', params:{brandPath: this.brandPath}}
            }}
          this.addFormFlg = false;
          if (err.customError) {
            error = Object.assign(error, err.customError);

            if(error.code == 400){
              this.apivalidationMessage =  error.message;
            }
          }
          if(error.code !== 400){
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }
        }).finally(()=> this.isLoading = false);

    if(!this.commonDownloadCSV(this.csvResponseData)){
      this.apivalidationMessage =  "CSVの出力に失敗しました。";
    }
    else{
      this.showContentCsv = true;
    }
  },
    closeModalMail() {
      this.showContentMail = false;
    },
    closeModelCsv() {
      this.showContentCsv = false;
    },
    selectItemClick() {
      if(this.selectAll) {
        this.selectAll = false;
      }
    },
    selectAllStore() {
      if(this.selectAll) {
        this.selectedStoreIds = this.alertListData.map((item) => item.id);
      } else {
        this.selectedStoreIds = [];
      }
    },
    setStoreId(id) {
      this.$store.dispatch('store/setStoreId', id)
      this.$router.push({name: 'dashboardAlertListChart' , params: {startDate: this.startDate, endDate: this.endDate, areaId: this.areaId}});
    },
    sortBy:function(key) {
      if(key === 'implementationRate') {
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      } else {
        if (this.sortKey !== key) {
          this.sortOrders[this.sortKey] = 1;
          require(`../assets/img/UpTriangleRed.png`)
          this.triangleImage[this.sortKey] = require(`../assets/img/UnderTriangleWhite.png`);
        }
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
        if (this.sortOrders[key] > 0) {
          this.triangleImage[key] = require(`../assets/img/UnderTriangleRed.png`);
        } else {
          this.triangleImage[key] = require(`../assets/img/UpTriangleRed.png`);
        }
      }
    },
    selectDateFormat(date){
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
  }
}
</script>
